import { createContext, useContext } from 'react';

export const rootContainerContext = createContext<ShadowRoot | null>(null);

export const RootContainerProvider = rootContainerContext.Provider;

export function useRootContainer() {
  return useContext(rootContainerContext);
}
